<template>
  <div class="col-md-12">
    <form>
      <div class="messages"></div>
      <div class="controls">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group has-error has-danger">
              <label class="floatLeft" for="form_name"
                >Message - Macedonian
                <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label
              >
              <input
                v-model="mk_message"
                id="mk_message"
                type="text"
                name="message in macedonian"
                class="form-control"
                v-bind:class="
                  errorMsg && !mk_message ? 'border-red' : 'border-none'
                "
                placeholder=""
                required="required"
                data-error="error"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group has-error has-danger">
              <label class="floatLeft" for="form_name"
                >Message - Albanian
                <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label
              >
              <input
                v-model="al_message"
                id="al_message"
                type="text"
                name="message in albanian"
                class="form-control"
                v-bind:class="
                  errorMsg && !al_message ? 'border-red' : 'border-none'
                "
                placeholder=""
                required="required"
                data-error="error"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group has-error has-danger">
              <label class="floatLeft" for="form_name"
                >Message - English
                <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label
              >
              <input
                v-model="en_message"
                id="en_message"
                type="text"
                name="message in english"
                class="form-control"
                v-bind:class="
                  errorMsg && !en_message ? 'border-red' : 'border-none'
                "
                placeholder=""
                required="required"
                data-error="error"
              />
            </div>
          </div>
        </div>
        <div v-if="errorMsg" class="row">
          <div class="col-md-12">
            <div class="error-infobox">
              {{ errorMsg }}
            </div>
          </div>
        </div>
        <div class="row floatLeft">
          <div class="col-md-12">
            <input
              @click.prevent="post_messages()"
              type="submit"
              class="btn btnDark btn-success btn-send pointer"
              value="Submit"
            />
            <input
              v-on:click="close_form(form_flag)"
              type="cancel"
              class="btn btn-secondary pointer button-width-helper"
              value="Cancel"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../store/index";
export default {
  props: {
    props: ["message"],
  },
  data() {
    return {
      mk_message: "",
      en_message: "",
      al_message: "",
      errorMsg: "",
    };
  },
  mounted() {},
  methods: {
    post_messages() {
      if (this.validate_form()) {
        axios.defaults.headers.common["Authorization"] =
          localStorage.getItem("accessToken");
        axios
          .post(store.state.BASE_URI + "admin/users/notify_users", {
            params: {
              message_mk: this.mk_message,
              message_en: this.en_message,
              message_al: this.al_message,
            },
            headers: {
              "Content-Type": "text/plain;charset=utf-8",
            },
          })
          .then((response) => {
            this.close_form(response.data.message);
            this.message = response.data.message;
            this.$toasted
              .show(response.data.message, { type: "success" })
              .goAway(2000);
          })
          .catch((error) => {
            if (error) {
              this.errorMsg = error.response.data.message;
              if (this.validate_form()) {
                this.$toasted
                  .show(this.errorMsg, {
                    type: "error",
                  })
                  .goAway(2000);
                this.close_form_bad();
              }
            }
          });
      } else {
        this.errorMsg = "Please fill all the required fields";
      }
    },
    close_form(message) {
      var flag = false;
      this.$emit("close", flag, message);
      this.$emit("msg", this.message);
      this.errorMsg = this.en_message = this.al_message = this.mk_message = "";
    },
    validate_form() {
      return this.mk_message == "" ||
        this.en_message == "" ||
        this.al_message == ""
        ? false
        : true;
    },
    close_form_bad() {
      var flag = false;
      this.$emit("close", flag);
      this.$emit("bad", this.message);
      this.errorMsg = this.en_message = this.al_message = this.mk_message = "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
